import { render, staticRenderFns } from "./declareService.vue?vue&type=template&id=0922c048&"
import script from "./declareService.vue?vue&type=script&lang=js&"
export * from "./declareService.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports